/**
 * Format large numbers into readable format (e.g., 23,494,649 -> 23.49M)
 * @param {number|string} downloads - The number to format
 * @returns {string} Formatted number (e.g., "23.49M", "100k", "500")
 */
export const formatDownloads = (downloads) => {
  if (!downloads || downloads === 0) return "N/A"

  const num = Number(downloads)
  if (isNaN(num)) return "N/A"

  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).replace(/\.?0+$/, '') + "M"
  } else if (num >= 1000) {
    return (num / 1000).toFixed(2).replace(/\.?0+$/, '') + "k"
  }

  // For numbers less than 1000, show as integer or with minimal decimals
  return num % 1 === 0 ? num.toString() : num.toFixed(0)
}
